import styled from 'styled-components'

const defaultSize = {
  small: 'width: 10rem;',
  medium: 'width: 14rem;',
  large: 'width: 18rem;',
  full: 'width: 100%;'
}

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 0.2rem;

  ${({size}) => defaultSize[size]}
  ${({hide}) => hide && 'padding: 0.8rem 1.5rem 0 0.5rem;'}
`
